export const GET_DASHBOARD_OVERVIEW = 'dashboardStats/getDashboardOverview';
export const GET_DASHBOARD_OVERVIEW_START = 'dashboardStats/getDashboardOverviewStart';
export const GET_DASHBOARD_OVERVIEW_COMPLETE =
  'dashboardStats/getDashboardOverviewCompleted';
export const GET_DASHBOARD_OVERVIEW_ERROR = 'dashboardStats/getDashboardOverviewError';

export const GET_DASHBOARD_MISSED_SHIFT_DATA = 'dashboardStats/getDashboardMissedShiftData';
export const GET_DASHBOARD_MISSED_SHIFT_DATA_START = 'dashboardStats/getDashboardMissedShiftDataStart';
export const GET_DASHBOARD_MISSED_SHIFT_DATA_COMPLETE =
  'dashboardStats/getDashboardMissedShiftDataCompleted';
export const GET_DASHBOARD_MISSED_SHIFT_DATA_ERROR = 'dashboardStats/getDashboardMissedShiftDataError';

export const GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA = 'dashboardStats/getDashboardTotalValueEarnedData';
export const GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_START = 'dashboardStats/getDashboardTotalValueEarnedDataStart';
export const GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_COMPLETE =
  'dashboardStats/getDashboardTotalValueEarnedDataCompleted';
export const GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA_ERROR = 'dashboardStats/getDashboardTotalValueEarnedDataError';

export const GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA = 'dashboardStats/getDashboardLiveDailyTrackerData';
export const GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_START = 'dashboardStats/getDashboardLiveDailyTrackerDataStart';
export const GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_COMPLETE =
  'dashboardStats/getDashboardLiveDailyTrackerDataCompleted';
export const GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA_ERROR = 'dashboardStats/getDashboardLiveDailyTrackerDataError';

export const GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA = 'dashboardStats/getDashboardProductivityScoreData';
export const GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_START = 'dashboardStats/getDashboardProductivityScoreDataStart';
export const GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_COMPLETE =
  'dashboardStats/getDashboardProductivityScoreDataCompleted';
export const GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA_ERROR = 'dashboardStats/getDashboardProductivityScoreDataError';

export const GET_DASHBOARD_TRAINING_GRAPH_DATA = 'dashboardStats/getDashboardTrainingGraphData';
export const GET_DASHBOARD_TRAINING_GRAPH_DATA_START = 'dashboardStats/getDashboardTrainingGraphDataStart';
export const GET_DASHBOARD_TRAINING_GRAPH_DATA_COMPLETE =
  'dashboardStats/getDashboardTrainingGraphDataCompleted';
export const GET_DASHBOARD_TRAINING_GRAPH_DATA_ERROR = 'dashboardStats/getDashboardTrainingGraphDataError';

export const GET_DASHBOARD_AVG_TENURE_DATA = 'dashboardStats/getDashboardAvgTenureData';
export const GET_DASHBOARD_AVG_TENURE_DATA_START = 'dashboardStats/getDashboardAvgTenureDataStart';
export const GET_DASHBOARD_AVG_TENURE_DATA_COMPLETE =
  'dashboardStats/getDashboardAvgTenureDataCompleted';
export const GET_DASHBOARD_AVG_TENURE_DATA_ERROR = 'dashboardStats/getDashboardAvgTenureDataError';

export const GET_DASHBOARD_GRAPH_OPTIONS = 'dashboardStats/getDashboardGraphOptions';
export const GET_DASHBOARD_GRAPH_OPTIONS_START = 'dashboardStats/getDashboardGraphOptionsStart';
export const GET_DASHBOARD_GRAPH_OPTIONS_COMPLETE =
  'dashboardStats/getDashboardGraphOptionsCompleted';
export const GET_DASHBOARD_GRAPH_OPTIONS_ERROR = 'dashboardStats/getDashboardGraphOptionsError';

export const GET_CAREGIVER_INCENTIVE_UTILIZATION = 'dashboardStats/getCaregiverIncentiveUtilization';
export const GET_CAREGIVER_INCENTIVE_UTILIZATION_START = 'dashboardStats/getCaregiverIncentiveUtilizationStart';
export const GET_CAREGIVER_INCENTIVE_UTILIZATION_COMPLETE =
  'dashboardStats/getCaregiverIncentiveUtilizationCompleted';
export const GET_CAREGIVER_INCENTIVE_UTILIZATION_ERROR = 'dashboardStats/getCaregiverIncentiveUtilizationError';

export const GET_TOP_FOUR_REWARDS = 'dashboardStats/getTopFourRewards';
export const GET_TOP_FOUR_REWARDS_START = 'dashboardStats/getTopFourRewardsStart';
export const GET_TOP_FOUR_REWARDS_COMPLETE =
  'dashboardStats/getTopFourRewardsCompleted';
export const GET_TOP_FOUR_REWARDS_ERROR = 'dashboardStats/getTopFourRewardsError';

export const GET_CAREGIVER_INCENTIVES_BRANCH_LIST = 'dashboardStats/getCaregiverIncentiesBranchList';
export const GET_CAREGIVER_INCENTIVES_BRANCH_LIST_START = 'dashboardStats/getCaregiverIncentiesBranchListStart';
export const GET_CAREGIVER_INCENTIVES_BRANCH_LIST_COMPLETE =
  'dashboardStats/getCaregiverIncentiesBranchListCompleted';
export const GET_CAREGIVER_INCENTIVES_BRANCH_LIST_ERROR = 'dashboardStats/getCaregiverIncentiesBranchListError';

export const UPDATE_ACTIVE_MENU_CLICK = 'dashboardStats/updateActiveMenuClick';
export const UPDATE_ACTIVE_PAGE_TITLE = 'dashboardStats/updateActivePageTitle';

export const FETCH_AGENCIES_REQUEST = 'dashboardStats/fetchAgenciesRequest';
 export const FETCH_AGENCIES_REQUEST_START = 'dashboardStats/fetchAgenciesRequestStart'
 export const FETCH_AGENCIES_REQUEST_COMPLETE = 'dashboardStats/fetchAgenciesRequestComplete';
 export const FETCH_AGENCIES_REQUEST_ERROR = 'dashboardStats/fetchAgenciesRequestError';
	 export const SET_SELECTED_AGENCY = 'dashboardStats/setSelectedAgency';

export const GET_SEND_CARE_COINS_ENABLED = 'dashboardStats/getSendCareCoinsEnabled';
export const GET_SEND_CARE_COINS_ENABLED_COMPLETE =
  'dashboardStats/getSendCareCoinsEnabledComplete';

export const GET_BALANCE_STATUS = 'dashboardStats/getBalanceStatus';
export const GET_BALANCE_STATUS_START = 'dashboardStats/getBalanceStatusStart';
export const GET_BALANCE_STATUS_COMPLETE = 'dashboardStats/getBalanceStatusCompleted';
export const GET_BALANCE_STATUS_ERROR = 'dashboardStats/getBalanceStatusError';

export const SET_BALANCE_STATUS_API_CALL_COMPLETE =
  'dashboardStats/setBalanceStatusApiCallComplete';

export const setBalanceStatusApiCallComplete = (payload = {}) => ({
  type: SET_BALANCE_STATUS_API_CALL_COMPLETE,
  payload,
});

export const getBalanceStatus = (payload = {}) => ({
  type: GET_BALANCE_STATUS,
  payload,
});
  
export const getCaregiverIncentiesBranchList = (payload = {}) => ({
  type: GET_CAREGIVER_INCENTIVES_BRANCH_LIST,
  payload,
});

export const getCaregiverIncentiveUtilization = (payload = {}) => ({
  type: GET_CAREGIVER_INCENTIVE_UTILIZATION,
  payload,
});

export const getTopFourRewards = (payload = {}) => ({
  type: GET_TOP_FOUR_REWARDS,
  payload,
});

export const getDashboardGraphOptions = (payload = {}) => ({
  type: GET_DASHBOARD_GRAPH_OPTIONS,
  payload,
});

export const updateActivePageTitle = (payload = {}) => ({
  type: UPDATE_ACTIVE_PAGE_TITLE,
  payload,
});

export const getDashboardProductivityScoreData = (payload = {}) => ({
  type: GET_DASHBOARD_PRODUCTIVITY_SCORE_DATA,
  payload,
});

export const getDashboardTrainingGraphData = (payload = {}) => ({
  type: GET_DASHBOARD_TRAINING_GRAPH_DATA,
  payload,
});

export const getDashboardAvgTenureData = (payload = {}) => ({
  type: GET_DASHBOARD_AVG_TENURE_DATA,
  payload,
});

export const updateActiveMenuClick = (payload = {}) => ({
  type: UPDATE_ACTIVE_MENU_CLICK,
  payload,
});

export const getDashboardLiveDailyTrackerData = (payload = {}) => ({
  type: GET_DASHBOARD_LIVE_DAILY_TRACKER_DATA,
  payload,
});

export const getDashboardTotalValueEarnedData = (payload = {}) => ({
  type: GET_DASHBOARD_TOATAL_VALUE_EARNED_DATA,
  payload,
});

export const getDashboardMissedShiftData = (payload = {}) => ({
  type: GET_DASHBOARD_MISSED_SHIFT_DATA,
  payload,
});

export const getDashboardOverview = (payload = {}) => ({
  type: GET_DASHBOARD_OVERVIEW,
  payload,
});
export const fetchAgenciesRequest = () => ({
  type: FETCH_AGENCIES_REQUEST,
});
export const setSelectedAgency = (agency) => ({
  type: SET_SELECTED_AGENCY,
  payload: { value: agency }
  });
export const getSendCareCoinsEnabledRequest = () => ({
  type: GET_SEND_CARE_COINS_ENABLED,
});
